export default __webpack_public_path__ + "static/media/leaf.7a990616.png";